import React, { ReactElement, useContext } from 'react';
import { getGiveawayAssets, GiveawayResponse } from '@oneaudi/avp-hck-dga-customerui-commons';
import styled from 'styled-components';
import { VerticalSpacing } from '../../common/spacings';
import { screen } from '../../common/breakpoints';
import { GiveawayContext } from '../../services/GiveawayContextService';

const StyledBeautyShotContainer = styled.div`
  width: 100%;
  display: flex;
  padding-top: ${VerticalSpacing.S};

  @media screen and ${screen.m} {
    padding-top: ${VerticalSpacing.M};
  }

  @media screen and ${screen.l} {
    padding-top: ${VerticalSpacing.L};
  }

  @media screen and ${screen.xl} {
    padding-top: ${VerticalSpacing.XL};
  }

  img {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const firstAsset = (assets: string[]): string | undefined => {
  if (!assets || assets.length === 0) {
    return undefined;
  }

  return assets[0];
};

export const BeautyShot = (): ReactElement => {
  const giveawayResponse: GiveawayResponse = useContext(GiveawayContext);
  const beautyShotLink =
    firstAsset(getGiveawayAssets(giveawayResponse, 'beauty-shot')) ??
    firstAsset(getGiveawayAssets(giveawayResponse, 'exterior'));

  if (!beautyShotLink) {
    return <></>;
  }

  return (
    <StyledBeautyShotContainer>
      <img src={beautyShotLink} alt="Beauty Shot" data-testid="beautyshot-image" />
    </StyledBeautyShotContainer>
  );
};
